import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { CenteredFlexColumn, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const StyledTitle = styled.p`
    ${setFontVariant("button", colorsPalettes.carbon[400])};

    margin: 0 0 4px;
`;

export const StyledSubtitle = styled.p`
    ${setFontVariant("report", colorsPalettes.carbon[400])};

    margin: 0;
    line-height: 18px;
`;

export const StyledMainContent = styled.div`
    margin: 20px 0 24px;
`;

export const StyledFooter = styled(CenteredFlexColumn)`
    row-gap: 4px;
`;

export const StyledTooltipContentWrapper = styled(FlexColumn)``;
